<!-- MACROM -->
<div class='quick-link'>
  <a href="javascript:void(0)" (click)="submitMarcomSSOForm();" class="external-link">
    {{ marcomLabel || 'Order Supplies-Over 65 (Marcom/ShopPro)' }}
    <span class="material-symbols-outlined">open_in_new</span>
  </a>
</div>
